import { Box, Text, CloseButton } from "@chakra-ui/react";
import React, { useState } from "react";

interface ErrorBarProps {
  message: string;
}

export const ErrorBar: React.FC<ErrorBarProps> = ({ message }) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible || !message) return null;

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      bg="red.500"
      color="white"
      py={3}
      px={6}
      zIndex={9999}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      shadow="md"
    >
      <Text fontWeight="bold">{message}</Text>
      <CloseButton color="white" onClick={() => setIsVisible(false)} />
    </Box>
  );
};
